import clubRequest from "../axios";
import {
  CalculateCustomerGroupDiscountSmsAmountPayload,
  CalculateGroupDiscountSmsAmountPayload,
  CreateCustomerGroupDiscountPayload,
  CreateDiscountGroupPayload,
  ValidateDiscountPayload,
} from "./type";

const getDiscountGroup = async () =>
  (await clubRequest.discountGroupList()).data;

const getDiscountByCode = async (code: string) =>
  (await clubRequest.discountDetail({ code })).data;

const validateDiscountByPurchase = async (params: ValidateDiscountPayload) =>
  (
    await clubRequest.discountValidateList({
      CustomerId: params?.customerId,
      DiscountCode: params?.discountCode,
      PurchaseAmount: params?.purchaseAmount,
    })
  ).data;

const getDiscountGroupCount = async (groupId: number) =>
  (await clubRequest.discountGroupCountDetail({ id: groupId })).data;

const getCustomerDiscounts = async (customerId: number) =>
  (await clubRequest.customerDiscountList({ customerId })).data;

const createDiscountByCustomerGroup = async (
  payload: CreateCustomerGroupDiscountPayload
) => (await clubRequest.discountCustomerGroupCreate(payload)).data;

const createDiscountByDiscountGroup = async (
  payload: CreateDiscountGroupPayload
) => (await clubRequest.discountGroupCreate(payload)).data;

const calculateDiscountAmount = async (
  payload: CalculateGroupDiscountSmsAmountPayload
) =>
  (await clubRequest.discountGroupCalculateSmsAmountCreate(payload)).data;

const calculateDiscountByCustomerGroupAmount = async (
  payload: CalculateCustomerGroupDiscountSmsAmountPayload
) =>
  (await clubRequest.discountCustomerGroupCalculateSmsAmountCreate(payload))
    .data;

export const discountService = {
  getDiscountGroup,
  getDiscountGroupCount,
  createDiscountByCustomerGroup,
  createDiscountByDiscountGroup,
  getDiscountByCode,
  getCustomerDiscounts,
  validateDiscountByPurchase,
  calculateDiscountAmount,
  calculateDiscountByCustomerGroupAmount,
};
